function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

import React, { Component } from 'react';
import t from 'prop-types';
import { Util } from '../index';
import ContenidoVentana from './contenido-ventana';
import VisorImagenes from '../visor-imagenes/components/visor-imagenes';
import ContenidosVisor from '../visor-imagenes/components/contenidos-visor';
import AreaImagen from '../visor-imagenes/components/area-imagen';
import BotoneraAreaImagenVisorDerecha from '../visor-imagenes/components/botonera-area-imagen-visor-derecha';
import BotoneraAreaImagenVisorIzquierda from '../visor-imagenes/components/botonera-area-imagen-visor-izquierda'; // const vinculoAbrirZona = (libroId, numPagina, numPaso) => ({
//     vinculo: `funcion,abrirZona:${libroId}${Util.pad3(numPagina)}.${numPaso}`
// })

var recurso = function recurso(libroId, numHistoria, num, version, extension) {
  return 'contenido/' + libroId + Util.pad2(numHistoria) + Util.pad2(num) + version + '.' + extension;
};

var ContenidoTipoHistoriaAuto = function (_Component) {
  _inherits(ContenidoTipoHistoriaAuto, _Component);

  function ContenidoTipoHistoriaAuto(props) {
    _classCallCheck(this, ContenidoTipoHistoriaAuto);

    var _this = _possibleConstructorReturn(this, _Component.call(this, props));

    _this.handlePlay = function () {
      // window.console.log("handlePlay " + this.state.playing, this.audio.current.paused)
      var playing = !_this.state.playing;
      var audio = _this.audio.current;

      if (playing) {
        audio.load();
        audio.play();
      } else {
        audio.pause();
      }

      _this.setState({
        playing: playing
      });
    };

    _this.siguiente = function () {
      var paso = _this.state.paso + 1;

      if (paso <= _this.props.numPasos) {
        _this.setState({
          paso: paso
        }, function () {
          var audio = _this.audio.current;
          audio.load();
          audio.play();
        }); // const vinculo = vinculoAbrirZona(libroId, numPagina, Number(numZona) + 1);
        // this.props.onBoton(vinculo, PRIMERA_VENTANA_ID);

      } else {
        _this.setState({
          paso: 1,
          playing: false
        }, function () {
          var audio = _this.audio.current;
          audio.load();
        });
      }
    };

    _this.state = {
      playing: false,
      audioSrc: '',
      imagenSrc: '',
      imagenSrcA: '',
      imagenes: [],
      paso: 0
    };
    _this.audio = React.createRef();
    return _this;
  }

  ContenidoTipoHistoriaAuto.getDerivedStateFromProps = function getDerivedStateFromProps(props, state) {
    var libroId = props.libroId,
        numHistoria = props.numHistoria,
        numZona = props.numZona;
    var paso = state.paso || Number(numZona);
    var imagenes = [];

    for (var i = paso; i < Math.min(paso + 3, props.numPasos); i++) {
      imagenes.push(recurso(libroId, numHistoria, i, '', 'png'));
      imagenes.push(recurso(libroId, numHistoria, i, 'a', 'png'));
    }

    var newState = {
      paso: paso,
      audioSrc: recurso(libroId, numHistoria, paso, '', 'mp3'),
      imagenSrc: recurso(libroId, numHistoria, paso, '', 'png'),
      imagenSrcA: recurso(libroId, numHistoria, paso, 'a', 'png'),
      imagenes: imagenes // window.console.dir(props, state, newState)

    };
    return newState;
  };

  ContenidoTipoHistoriaAuto.prototype.componentDidMount = function componentDidMount() {
    this.audio.current.addEventListener('ended', this.siguiente, false);
  };

  ContenidoTipoHistoriaAuto.prototype.componentWillUnmount = function componentWillUnmount() {
    this.audio.current.removeEventListener('ended', this.siguiente, false);
  };

  ContenidoTipoHistoriaAuto.prototype.componentDidUpdate = function componentDidUpdate(prevProps, prevState) {// const { playing, audioSrc } = this.state
    // if (playing && audioSrc !== prevState.audioSrc && this.audio.current) {
    //     const audio = this.audio.current
    //     audio.load()
    //     audio.play()            
    // }
  };

  ContenidoTipoHistoriaAuto.prototype.render = function render() {
    var _props = this.props,
        txtNumVineta = _props.txtNumVineta,
        children = _props.children;
    var _state = this.state,
        audioSrc = _state.audioSrc,
        imagenSrc = _state.imagenSrc,
        imagenSrcA = _state.imagenSrcA,
        imagenes = _state.imagenes,
        playing = _state.playing;
    return React.createElement(ContenidoVentana, null, React.createElement(VisorImagenes, {
      clasesExtra: 'historia',
      automatico: true
    }, React.createElement(AreaImagen, null, React.createElement(BotoneraAreaImagenVisorIzquierda, {
      txtNumVineta: txtNumVineta,
      onPlay: this.handlePlay,
      playing: playing
    }), React.createElement(ContenidosVisor, {
      src: imagenSrc,
      srcA: imagenSrcA,
      versionImagen: 'a'
    }, children), React.createElement(BotoneraAreaImagenVisorDerecha, null))), React.createElement('audio', {
      src: audioSrc,
      ref: this.audio
    }), imagenes.map(function (src, index) {
      return React.createElement('img', {
        key: 'key-imagen-' + index,
        src: src,
        style: {
          display: 'none'
        },
        alt: ''
      });
    }));
  };

  return ContenidoTipoHistoriaAuto;
}(Component);

ContenidoTipoHistoriaAuto.propTypes = process.env.NODE_ENV !== "production" ? {
  libroId: t.string,
  numHistoria: t.number,
  numZona: t.number,
  numPasos: t.number,
  txtNumVineta: t.string,
  children: t.any
} : {};
export default ContenidoTipoHistoriaAuto;